// extracted by mini-css-extract-plugin
export default {"PollCompletion_mainContainer":"PollCongratsPage_PollCompletion_mainContainer__Z8+DY","PollCompletion_thankYouContainer":"PollCongratsPage_PollCompletion_thankYouContainer__XMAoB"};